import React, {useEffect, useState} from 'react';

import {Box, Card, CardContent, CardMedia, Grid, Paper, Tooltip} from "@mui/material";

import ideasHeaderImage from '../../../graphics/Gemini_Generated_Image_98t8gj98t8gj98t8.png';
import Typography from "@mui/material/Typography";
import './ideas.css';
import IdeasCard from "./IdeasCard";
import dayjs from "dayjs";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";

import AddLocationAltRoundedIcon from "@mui/icons-material/AddLocationAltRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import IconButton from "@mui/material/IconButton";

function IdeasList(props) {

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const [eventIdeas, setEventIdeas] = useState(() => PA_GlobalObject?.Planning?.ideas ?? []);

    useEffect(() => {
        console.log("Planning.ideas : ",PA_GlobalObject.Planning.ideas);

        if (PA_GlobalObject.Planning.ideas !== undefined) {
            setEventIdeas([...PA_GlobalObject.Planning.ideas]);
        }

        if (PA_GlobalObject.Planning.ideas && PA_GlobalObject.Planning.ideas.length > 0) {

            for (const _idea of PA_GlobalObject.Planning.ideas) {
                console.log("Idea : "+_idea["title"]);
                if (_idea["photos"] !== undefined
                    && _idea["photos"].length === 0
                    && _idea["location"].google_place_id !== "") {
                    //get the photos
                    console.log("Getting photos for : "+_idea["location"].google_place_id);
                    const request = {
                        placeId: _idea["location"].google_place_id,
                        fields: ['photo']
                    };

                    const _global_map_service = new window.google.maps.places.PlacesService(props._global_map_ref.current);
                    _global_map_service.getDetails(request, function (results, status) {
                        console.log("response : "+results);
                        if (status === window.google.maps.places.PlacesServiceStatus.OK) {

                            try {
                                const _photos_array = [];
                                for (const _photo of results.photos) {
                                    _photos_array.push(_photo.getUrl({maxWidth: 175, maxHeight: 175}));
                                }
                                _idea.photos = _photos_array;

                                const ideaIndex = PA_GlobalObject.Planning.ideas.findIndex((idea) => idea.id === _idea.id);

                                if (ideaIndex !== -1) {
                                    // If the activity is found, update it in the eventIdeas array
                                    const updatedEventIdeasArray = [...PA_GlobalObject.Planning.ideas];
                                    updatedEventIdeasArray[ideaIndex] = _idea;

                                    setEventIdeas(updatedEventIdeasArray);

                                    //this updates the activity at the PAContext level
//                                    setPlanningIdeas(Planning["id"], updatedEventIdeasArray);

                                    console.log("updatedEventIdeas");
                                }

                            } catch (e){}
                        }
                    });
                }
            }
        }
    }, [PA_GlobalObject.Planning.ideas]);

    const updateIdeaDetails = (updatedIdea) => {
        console.log("trying to update idea : ", updatedIdea);

        // Find the index of the updated Idea in eventIdeas
        const ideaIndex = eventIdeas.findIndex((idea) => idea.id === updatedIdea.id);
        console.log("ideaIndex : ", ideaIndex);
        if (ideaIndex !== -1) {
            // If the idea is found, update it in the eventIdeas array
            const updatedEventIdeasArray = [...eventIdeas];
            updatedEventIdeasArray[ideaIndex] = updatedIdea;

            setEventIdeas(updatedEventIdeasArray);

            //this updates the idea at the PAContext level
            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning,
                    ideas: updatedEventIdeasArray
                },
            }));

            console.log("updatedEventIdeas");
        }

    };

    const deleteEventIdea = (idea_id) => {
        //delete the Idea from the eventIdeas
        const updatedIdeas = eventIdeas.filter((idea) => idea.id !== idea_id);
        setEventIdeas(updatedIdeas);

        //now set the Global
        set_PA_GlobalObject({
            ...PA_GlobalObject,
            Planning: {
                ...PA_GlobalObject.Planning,
                ideas: updatedIdeas,
            },
        });

    }
    const [isIdeasInfoDialogOpen, setIdeasInfoDialogOpen] = useState(false);




    return (
        <div className="ideas-list-container" >

            {/* --- IDEAS HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(99, 102, 241, 0.3)'
                        }}>
                            <i className="icon-lamp-bright" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4, whiteSpace: 'nowrap' }}>
                                Ideas
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <i className="icon-google" style={{ color: '#8b5cf6', fontSize: '10px' }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.1, whiteSpace: 'nowrap' }}>
                                    Sourced from Google Maps
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>

                        {/* Info Icon */}
                        <Tooltip title="About Ideas">
                            <IconButton
                                onClick={() => setIdeasInfoDialogOpen(!isIdeasInfoDialogOpen)}
                                sx={{ color: '#64748b' }}
                            >
                                <i className="icon-info-circle" style={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>

            {/* show the list of Ideas */}
            <div className="ideas-list-items-container">

                {
                    eventIdeas && eventIdeas.length > 0 ? (
                        eventIdeas
                            .sort((a, b) => dayjs(a.id).diff(dayjs(b.id)))
                            .map((ideaDetails) => (

                                <Grid item key={ideaDetails.id} sx={{display:'flex'}}>

                                    <IdeasCard
                                        eventIdea={ideaDetails}
                                        setEventIdea={updateIdeaDetails}
                                        setCurrentFeature={props.setCurrentFeature}
                                        deleteEventIdea={deleteEventIdea}
                                    />

                                </Grid>

                            ))
                    ) : (
                        <Grid item xs={12}>
                        <Paper elevation={3} sx={{ borderRadius: "5px", overflow: "hidden" }}>
                            <Card>
                                <CardMedia
                                    sx={{ height: 200 }}
                                    image={ideasHeaderImage}
                                    title="Spark the Plan"
                                />

                                <CardContent sx={{ padding: "24px" }}>
                                    {/* Title */}
                                    <Typography
                                        variant="h5"
                                        gutterBottom
                                        sx={{ fontWeight: 600, color: "#1565c0" }}
                                    >
                                        💡 No Ideas Yet
                                    </Typography>

                                    {/* Subhead */}
                                    <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
                                        Find places on Google Maps, add them as Ideas, and let everyone review,
                                        visit the website, and start a discussion.
                                    </Typography>

                                    {/* Feature list */}
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                        {/* Find anything on the map */}
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                                            <PublicRoundedIcon sx={{ fontSize: 24, color: "#1565c0" }} />
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    Find Anything on Google Maps
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Search restaurants, venues, parks, or attractions — if it’s on the map,
                                                    it can become an Idea.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Add as an Idea */}
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                                            <AddLocationAltRoundedIcon sx={{ fontSize: 24, color: "#2e7d32" }} />
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    Add as an Idea
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Save the place with its name, address, phone, and hours so it’s easy
                                                    for everyone to review later.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Learn more via website */}
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                                            <LinkRoundedIcon sx={{ fontSize: 24, color: "#5c6bc0" }} />
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    Learn More with the Website
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Each Idea links out to the venue’s website so attendees can explore menus,
                                                    photos, and details.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Comments / Questions */}
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                                            <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 24, color: "#f57c00" }} />
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    Kick Off the Discussion
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Attendees can ask questions, add comments, and share thoughts right on
                                                    the Idea card.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Group involvement */}
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                                            <GroupsRoundedIcon sx={{ fontSize: 24, color: "#37474f" }} />
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    Collaborative Planning
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Keep everyone informed and aligned as you decide which Ideas make it
                                                    into the event.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Call to Action */}
                                    <Box sx={{ mt: 4, textAlign: "center" }}>
                                        <Typography variant="body2" sx={{ fontStyle: "italic", color: "#616161" }}>
                                            Ready to spark inspiration? Let’s add your first Idea.
                                        </Typography>

                                    </Box>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                )

            }
        </div>

</div>
)

}

export default IdeasList;
